"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIconButton = void 0;
var React = require("react");
var IconButton_1 = require("../../IconButton");
var Close_1 = require("wix-ui-icons-common/on-stage/Close");
var CloseIconButton_st_css_1 = require("./CloseIconButton.st.css");
exports.CloseIconButton = function (props) {
    return React.createElement(IconButton_1.IconButton, __assign({ icon: React.createElement(Close_1.default, null) }, props, { className: CloseIconButton_st_css_1.classes.root }));
};
//# sourceMappingURL=CloseIconButton.js.map